// extracted by css-extract-rspack-plugin
export default {"lazyLoadObserver":"lazy-loading-LazyLoading-lazyLoadObserver-1b3e8fe5","lazyLoadObserverLoading":"lazy-loading-LazyLoading-lazyLoadObserverLoading-d00f73a9"};